import { Box } from '@mui/material';
import { styled, alpha } from '@mui/material/styles';

export const StyledBox = styled(Box)(({ theme: { palette } }) => ({
  backgroundColor: alpha(palette.common.white, 0.4),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  width: '100%',
}));
